export const getI18n = state => state.i18n.translations // eslint-disable-line import/prefer-default-export
